import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import "./index.css";
import { ApolloProviderWithClient } from "@common/utils/graphql";
import { RecoilRoot } from "recoil";
import posthog from "posthog-js";
import { env } from "@common/utils";
import { BrowserRouter } from "react-router-dom";
import * as Sentry from "@sentry/react";

Sentry.init({
  environment: env.stage,
  dsn: env.sentryDsn,
});

posthog.init(env.postHogKey, { api_host: env.postHogHost });

posthog.onFeatureFlags(function () {
  if (posthog.isFeatureEnabled("snowden")) {
    posthog.startSessionRecording();
  }
});

document.documentElement.classList.add("dark");

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RecoilRoot>
      <ApolloProviderWithClient>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ApolloProviderWithClient>
    </RecoilRoot>
  </React.StrictMode>,
);
